/**
 * Returns true if a raw submission should be shown given the inbox config.
 *
 * @param {Object} submission - Raw submission object from Redux state
 * @param {Array|null} inboxConfig - Array of inbox config strings, or null/undefined
 */
export function isSubmissionVisible(submission, inboxConfig) {
  if (!inboxConfig || !Array.isArray(inboxConfig) || inboxConfig.length === 0) {
    return true
  }
  for (var i = 0; i < inboxConfig.length; i++) {
    var configItem = inboxConfig[i]
    if (typeof configItem === 'string') {
      if (configItem === 'FormSubmissions') {
        return true
      }
      if (configItem.indexOf('FormSubmissions:') === 0) {
        var formId = configItem.substring('FormSubmissions:'.length)
        if (submission.formId === formId) {
          return true
        }
      }
    }
  }
  return false
}

/**
 * Returns true if a raw message should be shown given the inbox config.
 *
 * @param {Object} message - Raw message object from Redux state
 * @param {Array|null} inboxConfig - Array of inbox config strings, or null/undefined
 */
export function isMessageVisible(message, inboxConfig) {
  if (!inboxConfig || !Array.isArray(inboxConfig) || inboxConfig.length === 0) {
    return true
  }
  var category = message.category
  // Registration approval requests (bam-api-infrastructure postConfirmation)
  // are an admin's to act on, so no inbox filter hides them.
  if (category === 'RegistrationApprovals') {
    return true
  }
  for (var i = 0; i < inboxConfig.length; i++) {
    var configItem = inboxConfig[i]
    if (typeof configItem === 'string') {
      if (configItem === 'PublishRequests' && category === 'PublishRequests') {
        return true
      }
      if (
        configItem === 'PublishNotifications' &&
        category === 'PublishNotifications'
      ) {
        return true
      }
    }
  }
  return false
}
